import { Component, OnInit, OnDestroy } from '@angular/core';
import { StepService } from '../../services/step.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
// import { defaultTabs, defaultTabsFlowB } from '../../shared/tabs';v
// TOD: flowb
import { defaultTabs,  } from '../../shared/tabs';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit, OnDestroy {

  tabs!: any[];

  state!: string;

  step!: number;

  templateSuffix = environment.templateSuffix;

  destroy: Subject<boolean> = new Subject<boolean>();

  constructor(
    public stepService: StepService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'lupa',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/buro/lupa.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'riesgo',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        './assets/buro/riesgo.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'identidad',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        './assets/buro/identidad.svg'
      )
    );
  }

  ngOnInit(): void {
    // TODO: flowb
    // this.tabs = this.stepService.isFlow('A') ? defaultTabs : defaultTabsFlowB;
    this.tabs = defaultTabs;
    this.stepService.state.pipe(takeUntil(this.destroy)).subscribe((resp) => {
      this.state = resp;
      this.getClass();
    });
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }

  isMyStepLower(step: number) {
    return this.step < step;
  }

  getClass() {
    this.step = this.tabs.findIndex((tab) => tab.states.includes(this.state));
    this.stepService.tabNumber.next(this.step + 1);
  }


}
